import {
  lightDarkColor,
  contrastTextColor,
  opacityPercetColor,
} from 'src/utils/themeColor'

const theme = {
  colors: {
    base: {
      black: '#000000',
      white: '#FFFFFF',
      lightGray: '#F9F9F9',
      gray001: '#DDDDDD',
      gray: '#CCCCCC',
      gray100: '#C4C4C4',
      gray200: '#A4A4A4',
      gray300: '#5d5d5f',
      blue: '#0091ff',
      blue100: '#10284A',
      shadow: {
        alpha1: 'rgba(0, 0, 0, 0.1)',
        alpha2: 'rgba(0, 0, 0, 0.2)',
      },
      brandBlue: '#8089EE',
      lightBrandBlue: '#CCD0F8',
    },
    font: {
      dark: 'rgba(80, 80, 80, 0.5)',
      error: '#5F2120',
      warning: '#653C01',
      success: '#1D4620',
      info: '#024360',
      title: '#383838',
    },
    icon: {
      error: '#FF5252',
      warning: '#FB8C00',
      success: '#4CAF50',
      info: '#2196F3',
    },
    alert: {
      error: '#FCEDEC',
      warning: '#FFF4E5',
      success: '#EDF7ED',
      info: '#E5F5FD',
    },
    primary: {
      main: '#0214DC',
      main70: opacityPercetColor('#0214DC', 0.7),
      main50: opacityPercetColor('#0214DC', 0.5),
      main20: opacityPercetColor('#0214DC', 0.2),
      main5: opacityPercetColor('#0214DC', 0.05),
    },
    error: {
      main: '#FF5252',
      dark: lightDarkColor('#FF5252', -50),
      light: lightDarkColor('#FF5252', 50),
      contrastText: contrastTextColor('#FF5252'),
    },
    warning: {
      main: '#FB8C00',
      dark: lightDarkColor('#FB8C00', -50),
      light: lightDarkColor('#FB8C00', 50),
      contrastText: contrastTextColor('#FB8C00'),
    },
    success: {
      main: '#4CAF50',
      dark: lightDarkColor('#4CAF50', -50),
      light: lightDarkColor('#4CAF50', 50),
      contrastText: contrastTextColor('#4CAF50'),
    },
    info: {
      main: '#2196F3',
      dark: lightDarkColor('#2196F3', -50),
      light: lightDarkColor('#2196F3', 50),
      contrastText: contrastTextColor('#2196F3'),
    },
  },
  typograph: {
    fontsize: {
      base: 0.2,
      h1: '1rem',
      h2: '1.2rem',
      h3: '1.4rem',
      h4: '1.6rem',
      h5: '1.8rem',
      h6: '2rem',
      h7: '2.2rem',
      h8: '2.4rem',
      h9: '2.6rem',
      h10: '2.8rem',
    },
    fontFamily: {
      primary: 'Inter',
      secondary: 'Roboto',
    },
  },
  layout: {
    borderRadius: {
      small: '0.5rem',
      medium: '1rem',
      big: '2rem',
    },
    iconSize: {
      base: 0.8,
      small: '1.5rem',
      button: '2rem',
      medium: '2.5rem',
      big: '3rem',
    },
    margin: {
      base: 0.8,
      small: '0.8rem',
      medium: '1.6rem',
      big: '2.4rem',
    },
    padding: {
      base: 0.8,
      small: '0.8rem',
      medium: '1.6rem',
      big: '2.4rem',
    },
    gap: {
      base: 0.8,
      small: '0.8rem',
      medium: '1.6rem',
      big: '2.4rem',
    },
    lineHeight: {
      base: 0.8,
      small: '0.8rem',
      medium: '1.6rem',
      big: '2.4rem',
    },
    defaultSpacing: {
      base: 0.8,
      small: '0.8rem',
      medium: '1.6rem',
      big: '2.4rem',
    },
  },
  screen: {
    large: '1280px',
    medium: '980px',
    small: '767px',
    xsmall: '540px',
  },
}

const businessTheme = Object.assign(
  {},
  {
    ...theme,
    colors: {
      ...theme.colors,
      primary: {
        main: '#0214DC',
        main70: opacityPercetColor('#0214DC', 0.7),
        main50: opacityPercetColor('#0214DC', 0.5),
        main20: opacityPercetColor('#0214DC', 0.2),
        main5: opacityPercetColor('#0214DC', 0.05),
      },
    },
  }
)
const techTheme = Object.assign(
  {},
  {
    ...theme,
    colors: {
      ...theme.colors,
      primary: {
        main: '#009FE3',
        main70: opacityPercetColor('#009FE3', 0.7),
        main50: opacityPercetColor('#009FE3', 0.5),
        main20: opacityPercetColor('#009FE3', 0.2),
        main5: opacityPercetColor('#009FE3', 0.05),
      },
    },
  }
)
const vetTheme = Object.assign(
  {},
  {
    ...theme,
    colors: {
      ...theme.colors,
      primary: {
        main: '#186B89',
        main70: opacityPercetColor('#186B89', 0.7),
        main50: opacityPercetColor('#186B89', 0.5),
        main20: opacityPercetColor('#186B89', 0.2),
        main5: opacityPercetColor('#186B89', 0.05),
      },
    },
  }
)

export default theme
export { businessTheme, techTheme, vetTheme }
